







import { computed, defineComponent, PropType } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { SIZE } from "@/components/BaseAvatar/const";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "AvatarLiveCaption",
  components: { BaseIcon },
  props: {
    size: { type: String as PropType<SIZE>, default: () => SIZE.MEDIUM },
    liveChatType: { type: String, default: "public" },
  },
  setup(props) {
    const cationText = computed(() => {
      if (props.liveChatType === "collab") return $t("COLLAB LIVE");
      if (props.liveChatType === "private") return $t("PRIVATE LIVE");
      if (props.liveChatType === "event") return $t("EVENT LIVE");
      return $t("SINGLE LIVE");
    });
    const isTextCaption = computed(() => props.size === SIZE.BIG || props.size === SIZE.MEDIUM);

    return {
      isTextCaption,
      cationText,
      SIZE,
    };
  },
});
